export const TOAST_ERROR_RESET = 'TOAST_ERROR_RESET'
export const TOAST_ERROR_RETURN = 'TOAST_ERROR_RETURN'